<input placeholder="Current Zoning Code Name" [value]="(zoningCode$ | async)?.Name" readonly=true>
